<template>
  <div
    class="fixed inset-0 z-[9999] bg-black bg-opacity-50 backdrop-blur-3xl text-left transition-all duration-[600ms] pointer-events-auto"
    v-if="isOpen"
    @click.self="$emit('close')"
  >
    <div class="bg-white bg-opacity-50 backdrop-blur-md py-[2.4rem] px-8">
      <div class="flex justify-between items-center">
        <router-link :to="{ name: 'Home' }" class="logo" @click="$emit('close')">
          <img src="@/assets/images/logo.png" alt="Logo" />
        </router-link>
        <button class="hamburger" @click="$emit('close')">
          <img src="@/assets/images/Hamburger_close.svg" alt="Cerrar menú" />
        </button>
      </div>
    </div>

    <div class="px-8 pt-12 pb-16 h-[calc(100vh-7rem)] flex flex-col mt-10">
      <ul class="offcanvasNav">
        <li>
          <router-link :to="{ name: 'Home' }" @click="$emit('close')">{{ $t("Home") }}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Login' }" @click="$emit('close')">{{ $t("Login") }}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Register' }" @click="$emit('close')">{{ $t("Register") }}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'ArticlesView' }" @click="$emit('close')">{{ $t("Articles") }}</router-link>
        </li>
      </ul>
      <div class="login_wrap"></div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "MarketHeaderHamburger",
  props: {
    selectedHeader: {
      type: String,
      required: false,
      default: "",
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close"],
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
  watch: {
    isOpen: {
      handler(val) {
        if (typeof document === "undefined") return;
        const className = "overflow-hidden";
        if (val) {
          document.body.classList.add(className);
        } else {
          document.body.classList.remove(className);
        }
      },
      immediate: true,
    },
  },
  beforeUnmount() {
    if (typeof document !== "undefined") {
      document.body.classList.remove("overflow-hidden");
    }
  },
});
</script>

<style scoped>
.offcanvasNav a {
  color: #fff;
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.16;
  letter-spacing: 0.96px;
  text-transform: uppercase;
}

.offcanvasNav li:not(:last-child) {
  margin-bottom: 3.2rem;
}
</style>
